<app-widget-option [categories]="['LAYERS']" [label]="'HIDE_MIN_MAX'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).gaugeHideMinMax" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>